import { render, staticRenderFns } from "./SalaryCertificate.vue?vue&type=template&id=1a78e6c2&scoped=true"
import script from "./SalaryCertificate.vue?vue&type=script&lang=js"
export * from "./SalaryCertificate.vue?vue&type=script&lang=js"
import style0 from "./SalaryCertificate.vue?vue&type=style&index=0&id=1a78e6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78e6c2",
  null
  
)

export default component.exports